<script setup lang="ts">
  import MultiSelect from "primevue/multiselect";
  import { useField } from "vee-validate";
  import Message from "@/ui/message/message.vue";

  MultiSelect.compatConfig = {
    MODE: 3,
  };

  const props = withDefaults(
    defineProps<{
      name: string;
      label?: string;
      required?: boolean;
      filter?: boolean;
    }>(),
    {
      filter: true,
    },
  );
  const { value: localValue, errorMessage } = useField(() => props.name);
</script>

<template>
  <div class="flex flex-col gap-[4px]">
    <label v-if="label" class="text-[14px] font-normal">
      {{ label }}
      <span v-if="required" class="text-[#FF55C6]">*</span>
    </label>
    <MultiSelect v-model="localValue" :filter="filter" :showToggleAll="filter" display="chip" v-bind="$attrs" :invalid="!!errorMessage">
      <template #chipicon="{ removeCallback }">
        <i class="pi pi-times-circle" @click="removeCallback" />
      </template>
    </MultiSelect>
    <Message class="errorMessage" v-if="errorMessage" severity="error" size="small" variant="simple" :text="errorMessage" />
  </div>
</template>
